export const SCHEDULE_LOCATIONS = [
    "In Store - Castle",
    "In Store - West wing",
    "Coin Show",
    "Time Off",
] as const;

export const getScheduleLocationLabel = (location: string): string => {
    if (location === "In Store") return "In Store - Castle";
    return location;
};
